/* loaded by smart-asset */
export default require("./satellite~JtEKpLhg.jpg")